import { Injectable, EventEmitter } from '@angular/core';

interface Cookie {
  name: string,
  value: string
}

@Injectable({
  providedIn: 'root',
})
export class CookieConsentService {

  cookieConsentEmitter = new EventEmitter<string>();
  cookieDomain: string;
  cookiesList: Array<Cookie>;
  cookieAnalyticsList = ['_ga', '_gid', '_gat_gtag_UA_473207_16'];

  constructor() {
    this.setCookieDomain();
    this.populateCookies();
  }

  set(value: string, name: string = "eu_cookieconsent") {
    if(name === 'eu_cookieconsent' && value === 'deny') {
      this.cookieAnalyticsList.forEach(cookie => {
        this.deleteCookie(cookie);
      })
    }

    const date = new Date();
    date.setTime(date.getTime() + 182 * 24 * 60 * 60 * 1000);
    const expires = 'expires=' + date.toUTCString();

    document.cookie = name + '=' + value + ';domain=' + this.cookieDomain + ';' + expires + ';path=/';

    this.populateCookies();
    this.cookieConsentEmitter.emit(value);
  }

  get(name: string = "eu_cookieconsent"): string | undefined {
    if(this.cookiesList && this.cookiesList.find(el => el.name === name)) {
      return this.cookiesList.find(el => el.name === name).value;
    }
  }

  deleteCookie(name: string, domain?: string) {
    domain ? this.cookieDomain = domain : null;
    document.cookie = name + '=; domain=' + this.cookieDomain + ';expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/';

    this.populateCookies();
  }

  resetAllCookies() {
    if (this.cookiesList) {
      this.cookiesList.forEach((cookie) => {
        this.deleteCookie(cookie.name);
      });
      this.populateCookies();
    }
  }

  private setCookieDomain() {

      const domainSplit = document.location.hostname.split(".");
      if(domainSplit.length === 1) {
        this.cookieDomain = domainSplit[0];
      } else {
        this.cookieDomain = '.' + domainSplit[1] + '.' +domainSplit[2];
      }


  }

  private populateCookies() {
    if (document.cookie !== '') {
      const cookieList = document.cookie.split(';');
      this.cookiesList = cookieList.map((cookieNode) => {
        const cookieArray = cookieNode.split('=');
        return { name: cookieArray[0].trim(), value: cookieArray[1].trim() };
      });
    }
  }
}
